import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText, formatVal } from '../../../../../helpers/value'
import { TranslateDay } from '../../../../common/text/TranslateCustom'
import { expiryDate } from '../../helper'
import classes from '../../index.module.scss'

export const ListReport = ({ page, data }) => {
  const formatData = data.slice((page - 1) * 2, page * 2)

  return (
    <div className="dFlex flex1" style={{ gap: 4 }}>
      <div className="w50">
        <ItemReport data={formatData[0]} />
      </div>
      <div className="w50">
        {formatData[1] && <ItemReport data={formatData[1]} />}
      </div>
    </div>
  )
}

export const ItemReport = ({ data }) => {
  const locale = useSelector((state) => state.i18n.local)
  return (
    <Element
      className={`${classes.itemReport} flexColumn `}
      style={{
        backgroundColor: '#F3F3F3',
        borderRadius: 8,
        gap: 8,
      }}
    >
      <Element className={`${classes.title} fw600`}>
        <TextEllipsisStaticLine
          text={formatText(data?.fiinGateReportTypeName)}
          lineClamp={1}
          isI18n={false}
        />
      </Element>
      <div
        className="dFlex justifyContentBetween alignItemsCenter"
        style={{ paddingBottom: 4 }}
      >
        <Element>
          <Translate value="dashboard.currentPlan.remaining" />:
        </Element>
        <Element
          className="fw600 whiteSpaceNowrap"
          style={{ color: '#3DA967' }}
        >
          {formatVal(data?.quantity || 0, locale, false, 0)}/
          {formatVal(data?.initQuantity || 0, locale, false, 0)}
        </Element>
      </div>
      <Element className="dFlex alignItemsEnd" style={{ color: '#0553A5' }}>
        <Icon
          className="icon-clock"
          style={{ fontSize: 13, paddingRight: 4 }}
        />
        <TranslateDay count={expiryDate(data?.endDate)} />
      </Element>
    </Element>
  )
}
